import { dispatchFBEvent, ecommerce } from '@uds/tagmg';
import { selectors as productSelectors } from '@uds/product';
import { GetProductData } from 'core/cta';
import { getLanguageCookie } from 'domain/selectors/common';

const sendProductOnAddToBasket = ({
  productId,
  list,
  getProductData,
  currency,
}: {
  list: string;
  productId?: string | null;
  getProductData: GetProductData;
  currency?: string;
}) => {
  const locale = getLanguageCookie();
  if (!productId) {
    return;
  }
  return getProductData({
    skuId: productId,
    locale,
  }).then((product) => {
    let price = 0;
    // in case we ever get a malformed product, getPrice would throw an error
    try {
      price = productSelectors.getPrice({
        product,
        includeTax: false,
      });
    } catch (e) {
      return;
    }
    if (product == null) return;
    const id = product.id;
    const name = product.name;
    const category = product.categoryName;
    dispatchFBEvent('AddToCart', {
      // eslint-disable-next-line camelcase
      content_ids: [id],
      // eslint-disable-next-line camelcase
      content_name: name,
      value: price,
      quantity: 1,
      // eslint-disable-next-line camelcase
      content_type: category,
      currency: currency,
    });
    ecommerce([
      [
        'addProduct',
        {
          id: `${id}`,
          name,
          price,
        },
      ],
      [
        'setAction',
        'add',
        {
          list,
        },
      ],
    ]);
  });
};

export default sendProductOnAddToBasket;
